import React, { Component } from 'react';
import ReactAvatar from 'react-avatar';

const COLORS = [
  '#00875A',
  '#025EDB',
  '#2882FF',
  '#0BAE6D',
  '#00C7E6',
  '#FBB13C',
  '#ED3360',
  '#ED1C25',
  '#FF7226',
  '#6555C0',
];

/**
 * @typedef {{
 *  src?: string,
 *  alt?: string,
 *  style?: React.CSSProperties,
 *  size?: number | string,
 *  className?: string,
 *  customColor?: string
 * }} Props
 * @extends {Component<Props>}
 */
export default class Avatar extends React.Component {
  render() {
    const {
      src, alt, style, size, className, customColor
    } = this.props;
    const slicedName = alt ? alt.split(' ') : '';
    const firstName = slicedName[0];
    const lastName = slicedName.length > 1 ? slicedName[slicedName.length - 1] : '';

    let firstLetters = firstName[0] + lastName[0];
    if (typeof firstLetters !== 'string') firstLetters = 'aa'; // default value

    const colorString = firstLetters
      .toLowerCase()
      .replace(/\w/g, (text) => text.charCodeAt(0).toString(10));
    const colorIndex = parseInt(colorString.charAt(colorString.length - 1), 10);
    const safeColorIndex = colorIndex >= COLORS.length ? COLORS.length - 1 : (colorIndex || 0);
    const color = COLORS[safeColorIndex];

    return (
      <div style={{ display: 'inline-block' }}>
        <ReactAvatar
          className={className}
          size={`${size || 2}rem`}
          name={`${firstName}${lastName ? ` ${lastName}` : ''}`}
          src={src}
          maxInitials={2}
          color={customColor || color}
          style={style}
          textSizeRatio={1}
          round
        />
      </div>
    );
  }
}
